module.exports = __webpack_public_path__ + "static/media/layout-default.f2f77dfe.svg";